module.exports = __webpack_public_path__ + "img/MANUAL_ID.47a4b45e.svg";